import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import SEO from '../config/seo.json';

const SITE_URL = (process.env.REACT_APP_SITE_URL || SEO.siteUrl).replace(/\/$/, '');
const absolute = (p) => (/^https?:\/\//.test(p) ? p : `${SITE_URL}${p.startsWith('/') ? '' : '/'}${p}`);

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setCanonical(href) {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', 'canonical');
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

/** Apply title / description / canonical / Open Graph / Twitter tags for the current page. */
export function applySeo({ title, description, path, image, type = 'website', noindex = false }) {
  const fullTitle = title || SEO.routes['/'].title;
  const desc = description || SEO.routes['/'].description;
  const url = absolute(path || '/');
  const img = absolute(image || SEO.defaultImage);
  document.title = fullTitle;
  setMeta('name', 'description', desc);
  setMeta('name', 'robots', noindex ? 'noindex, follow' : 'index, follow');
  setCanonical(url);
  setMeta('property', 'og:type', type);
  setMeta('property', 'og:url', url);
  setMeta('property', 'og:title', fullTitle);
  setMeta('property', 'og:description', desc);
  setMeta('property', 'og:image', img);
  setMeta('name', 'twitter:title', fullTitle);
  setMeta('name', 'twitter:description', desc);
  setMeta('name', 'twitter:image', img);
}

/** Applies the static per-route SEO from config/seo.json on every navigation. */
export default function SeoManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    const path = pathname.replace(/\/+$/, '') || '/';
    const route = SEO.routes[path];
    if (route) {
      applySeo({ ...route, path: route.canonical || path });
    } else if (path.startsWith('/company/')) {
      applySeo({ title: `Portfolio | ${SEO.siteName}`, path, noindex: true });
    } else {
      // Unknown or unlisted pages (e.g. /company/*, 404) stay out of search results.
      applySeo({ title: `Page not found | ${SEO.siteName}`, path, noindex: true });
    }
  }, [pathname]);
  return null;
}
